module.exports = __webpack_public_path__ + "img/baidu.eeb0004a.png";